import React, { useState, useEffect } from 'react'
import DashboardBlock from './dashboardwidgetsblock';
import Selfassignpopupscreenui from './selfassignpopupscreenui'


export default function ViolationForPlazaReview({ violationDataUnassign, totalCount, setGlobalAssignedToMe, globalassignedtome,  setGlobalActiveViolation,loading,  jsonData }) {
    const [amount, setAmount] = useState(0);
    const [violationforplaza, setViolationforPlaza] = useState(0);
    const [Show1, setShow1] = useState(false);
    // const [loading, setLoading] = useState(false);


    useEffect(() => {
        const data = violationDataUnassign;
        if (data.cases) {
            setViolationforPlaza(data.cases);
            setAmount(data.sumAmount);
            setGlobalActiveViolation(data.cases)
        } else {
            setViolationforPlaza(0);
            setAmount(0);
            setGlobalActiveViolation(0);
        }
        // eslint-disable-next-line
    }, [violationDataUnassign, totalCount]);

    return (
        <div style={{position:'relative'}}>
            <Selfassignpopupscreenui
                origin="dashboardassign" 
                activeCount={violationforplaza}
                show1={Show1}
                jsonD={jsonData}
                updateActiveCount={setViolationforPlaza}
                setShow1={setShow1}
                setAssingToMeCount={totalCount}
                setGlobalAssignedToMe={setGlobalAssignedToMe}
                globalassignedtome={globalassignedtome}
            />
            <DashboardBlock
                classname="violence-block"
                title="Violation for plaza review/action"
                titlecolor={"#707070"}
                count={violationforplaza}
                countcolor="#303A78"
                total={totalCount}
                showpercent={true}
                percentcolor="#707070"
                amount={amount}
                amount_color="#707070"
                btnname="Assign to me"
                loader={loading} 
                modalBtn={true}
                showModal={setShow1} 
                paddingTop="25px"/>
        </div>
    )
}
